import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/tmp/build_c575918f/src/layouts/default.vue").then(m => m.default || m))
}